const checkLoggedIn = ()=>{
    let login = localStorage.getItem('login');
    if(login){
        return true
    }
    return false
}
module.exports={checkLoggedIn}